module.exports = __webpack_public_path__ + "static/media/autodeskLogo.8931947f.png";